export const Form = (props: any) => {
  // const classes = useStyles();
  const { children, autoComplete = 'on', ...other } = props;
  return (
    <form autoComplete={autoComplete} {...other}>
      {props.children}
    </form>
  );
};
